import { routeName } from '../constants';

export const isHomePage = pathname => pathname === routeName.HONE;

export const isSegmentPage = pathname =>
    pathname.startsWith(routeName.SEGMENT_PRODUCT) ||
    pathname.startsWith(routeName.NEW_SEGMENT_PRODUCT);

export const formatPageTitle = isLANResuming => (isLANResuming ? 'RESUMING' : undefined);
